export const animationMissingJointTest = ({
	buildsignature,
	categoryid,
	createtime,
	desyncdata,
	desyncid,
	screenshot,
	sessionid,
	sku,
	systemconfig,
	type,
	version,
}) => {
	if (desyncdata !== undefined) {
		if (desyncdata.indexOf('KeyError: \'get_joint_transform_from_rig') !== -1 && desyncdata.indexOf('was not found in the specified rig') !== -1) {
            var extraInfo = ''

            if (desyncdata.indexOf('object_HomeChefStation') !== -1) {
                extraInfo = '<br/><br/>This specific error was most likely caused by the Chef Cooking Station. Try replacing it or move it to a better spot.'
            }

            if (desyncdata.indexOf('Joint name [b__subroot__9] was not found') !== -1) {
                extraInfo = '<br/><br/>This specific error was most likely caused by an outdated Custom Content Bed. Remove Custom Content Bed to resolve this issue.'
            }

			return {
				type: 'animationMissingJointTest',
				color: 'Goldenrod',
				title: 'Animation Missing Transform Joint Error',
				text: 'An issue with the animations rigging system.',
				description: 'An animation failed to find and use an object slot on the animation rigging skeleton.' + extraInfo +
                '<br/><br/>In most cases, you\'re safe to ignore this error.'
			}
		}
	}
}

// EXAMPLE
/*
<root>
    <report>
        <version>2</version>
        <sessionid>f1f4a15946272df75b4c5b65</sessionid>
        <type>desync</type>
        <sku>ea.maxis.sims4_64.15.pc</sku>
        <createtime>2099-07-16 05:54:38</createtime>
        <buildsignature>Local.Unknown.Unknown.1.99.88.1020-1.200.000.354.Release</buildsignature>
        <categoryid>__init__.py:239</categoryid>
        <desyncid>f1f4a15946272df75b4c5b65</desyncid>
        <systemconfig/>
        <screenshot/>
        <desyncdata>ANIMATION: A clip is trying to fire a parent event with bad
                data. Either the animation actors are mistuned, or a slot
                that doesn't exist on the rig has been specified in Maya.
                
                ASMs: 
                
                 Clip: a2o_pot_cook_stir_highSkill_succeed_x (Parent Event ID: 4),
                 Parenting object_SaucePot_NoPickup:0x0b0107cef15803db to object_HomeChefStation:0x0b0107cee504002d,
                 Slot 0x65e1ecb0 on '00000000!d09f4ba4'31412808.8eaf13de',
                 Offset: Transform(Vector3(0.000000, 0.000000, 0.000000), Quaternion(0.000000, 0.000000, 0.000000, 1.000000))
                 (KeyError: 'get_joint_transform_from_rig: Joint name [(null)] was not found in the specified rig [d09f4ba431412808.8eaf13de]. JointNameHash [0x65e1ecb0]().')
Traceback (most recent call last):
  File &quot;T:\InGame\Gameplay\Scripts\Core\sims4\utils.py&quot;, line 179, in wrapper
  File &quot;T:\InGame\Gameplay\Scripts\Server\areaserver.py&quot;, line 205, in c_api_server_tick
  File &quot;T:\InGame\Gameplay\Scripts\Server\zone.py&quot;, line 464, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\time_service.py&quot;, line 112, in update
  File &quot;T:\InGame\Gameplay\Scripts\Server\scheduling.py&quot;, line 212, in simulate
  File &quot;T:\InGame\Gameplay\Scripts\Server\elements.py&quot;, line 376, in _run
  File &quot;T:\InGame\Gameplay\Scripts\Server\animation\animation_utils.py&quot;, line 417, in flush_all_animations
  File &quot;T:\InGame\Gameplay\Scripts\Server\animation\arb_accumulator.py&quot;, line 499, in flush
  File &quot;T:\InGame\Gameplay\Scripts\Server\animation\arb_accumulator.py&quot;, line 399, in _append_arb_to_element
  File &quot;T:\InGame\Gameplay\Scripts\Server\animation\arb_element.py&quot;, line 245, in execute_and_merge_arb
  File &quot;T:\InGame\Gameplay\Scripts\Server\animation\arb_element.py&quot;, line 272, in handle_events
  File &quot;T:\InGame\Gameplay\Scripts\Core\native\animation\arb.py&quot;, line 385, in handle_events
  File &quot;T:\InGame\Gameplay\Scripts\Server\animation\arb_element.py&quot;, line 558, in _event_handler_parent
  File &quot;T:\InGame\Gameplay\Scripts\Server\animation\arb_element.py&quot;, line 538, in _event_handler_parent
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\client_object_mixin.py&quot;, line 1501, in set_parent
  File &quot;T:\InGame\Gameplay\Scripts\Server\objects\client_object_mixin.py&quot;, line 1461, in create_parent_location
  File &quot;T:\InGame\Gameplay\Scripts\Core\native\animation\__init__.py&quot;, line 239, in get_joint_transform_from_rig
KeyError: 'get_joint_transform_from_rig: Joint name [(null)] was not found in the specified rig [d09f4ba431412808.8eaf13de]. JointNameHash [0x65e1ecb0]().'
</desyncdata>
    </report>
</root>
*/



// WEBPACK FOOTER //
// ./src/tests/basegame/animationMissingJointTest.js